import React from "react";
import {
  MixBasketSummary,
  MixMaterialBasketSummary,
  MaterialRead,
} from "src/store/api/generatedApi";
import { SearchMixDetailsProvider } from "./context/SearchMixDetailsContext";
import { BasketsTabContent } from "./components/basketsTab/BasketsTabContent";

interface BasketsTabProps {
  mixBasketsSummary: MixBasketSummary[];
  mixMaterialBasketsSummary: MixMaterialBasketSummary[];
  materials: MaterialRead[];
}

export const BasketsTab: React.FC<BasketsTabProps> = ({
  mixBasketsSummary,
  mixMaterialBasketsSummary,
  materials,
}) => {
  return (
    <SearchMixDetailsProvider
      mixBasketsSummary={mixBasketsSummary}
      mixMaterialBasketsSummary={mixMaterialBasketsSummary}
      materials={materials}
    >
      <BasketsTabContent />
    </SearchMixDetailsProvider>
  );
};
